"use client";

import type { UseRequestQueryProps } from "../../../../request/hooks/useRequestQuery";
import { useRequestQuery } from "../../../../request/hooks/useRequestQuery";
import { keyCommunitiesAdminCommunity } from "./keyCommunitiesAdminCommunity";
import { requestCommunitiesAdminCommunityProps } from "./requestCommunitiesAdminCommunity";

export type UseRequestCommunitiesAdminCommunityProps = {
  id: number;
  queryOptions?: UseRequestQueryProps;
};

export const useRequestCommunitiesAdminCommunity = ({
  id,
  queryOptions = {},
}: UseRequestCommunitiesAdminCommunityProps) => ({
  query: useRequestQuery({
    ...queryOptions,
    queryFnRequestProps: {
      urlBackendPath: `/communities/${id}`,
      ...requestCommunitiesAdminCommunityProps,
    },
    queryKey: keyCommunitiesAdminCommunity({ id }),
  }),
});
